import { toMoney, toPercent, toDecPercent, getNumber } from '@utils/Format'

export const buildMapClassRent = ({
  estatisticasClasse = {},
  mapperBenchmarks = {},
  benchmarks = [],
}) => {
  const cdiBenchmark = findCDIBenchmark(benchmarks)
  const entries = Object.entries(estatisticasClasse || {}).filter(
    (e) => e[0] !== 'Todos'
  )
  const result = {}

  for (let i = 0; i < entries.length; i++) {
    const key = entries[i][0]
    const stats = entries[i][1] || {}
    const mapped = (mapperBenchmarks || {})[key]
    const benchmarkId = resolveBenchmarkId(mapped, cdiBenchmark)
    const benchStats = extractBenchStats(stats, benchmarkId)
    const benchObj = findBenchmarkObj(benchmarks, benchmarkId)

    result[key] = formatClassRent({
      classStats: stats || {},
      classBenchStats: benchStats,
      benchmark: benchObj,
    })
  }
  return result
}

export const computeClasses = ({ carteiraTabela = {}, viewByClass = {} }) => {
  return Object.entries(carteiraTabela || {})
    .map((pair) => {
      const className = pair[0]
      const group = pair[1] || {}
      const carteiraCopy = (group.carteira || []).slice(0)
      carteiraCopy.sort(
        (a, b) => ((b && b['Aplicação']) || 0) - ((a && a['Aplicação']) || 0)
      )
      const view = viewByClass[className] || {
        sum: 0,
        sumFmt: toMoney(0),
        pctFmt: toPercent(0),
      }
      return [
        className,
        {
          ...group,
          carteira: carteiraCopy,
          _sumApplied: view.sum,
          sumFmt: view.sumFmt,
          pctFmt: view.pctFmt,
        },
      ]
    })
    .sort(
      (a, b) =>
        getNumber((b[1] && b[1]['Aplicação']) || 0) -
        getNumber((a[1] && a[1]['Aplicação']) || 0)
    )
}

export const computeTotalInvested = (carteiraTabela = {}) => {
  const values = Object.values(carteiraTabela)
  let total = 0
  for (let i = 0; i < values.length; i++) {
    const arr = (values[i] && values[i].carteira) || []
    for (let j = 0; j < arr.length; j++) {
      const ap = arr[j] && arr[j]['Aplicação']
      total += ap > -1 ? ap : 0
    }
  }
  return total
}

export const buildViewByClass = ({
  carteiraTabela = {},
  totalInvested = 0,
}) => {
  const entries = Object.entries(carteiraTabela)
  const res = {}
  for (let i = 0; i < entries.length; i++) {
    const className = entries[i][0]
    const group = entries[i][1] || {}
    const arr = group.carteira || []
    let sum = 0
    for (let j = 0; j < arr.length; j++) {
      const ap = arr[j] && arr[j]['Aplicação']
      sum += ap > -1 ? ap : 0
    }
    const pct = ((sum || 0) / (totalInvested || 1)) * 100
    res[className] = { sum, sumFmt: toMoney(sum), pctFmt: toPercent(pct, 1) }
  }
  return res
}

export const buildAssetPctById = ({
  carteiraTabela = {},
  totalInvested = 0,
}) => {
  const values = Object.values(carteiraTabela)
  const res = {}
  for (let i = 0; i < values.length; i++) {
    const arr = (values[i] && values[i].carteira) || []
    for (let j = 0; j < arr.length; j++) {
      const a = arr[j] || {}
      const ap = a['Aplicação'] > -1 ? a['Aplicação'] : 0
      const pct = (ap / (totalInvested || 1)) * 100
      res[a.id] = toPercent(pct, 1)
    }
  }
  return res
}

export const buildAllAssetIds = (carteiraTabela = {}) => {
  const values = Object.values(carteiraTabela)
  const ids = []
  for (let i = 0; i < values.length; i++) {
    const arr = (values[i] && values[i].carteira) || []
    for (let j = 0; j < arr.length; j++) ids.push(arr[j].id)
  }
  return ids
}

export const buildFlatAssets = (carteiraTabela = {}) => {
  const values = Object.values(carteiraTabela)
  const list = []
  for (let i = 0; i < values.length; i++) {
    const arr = (values[i] && values[i].carteira) || []
    for (let j = 0; j < arr.length; j++) list.push(arr[j])
  }
  return list
}

export const buildClassStatsFmt = (estatisticasClasse = {}) => {
  const keys = Object.keys(estatisticasClasse)
  const vol = {}
  const inicio = {}
  const rend = {}
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (k === 'Todos') continue
    const v = estatisticasClasse[k] || {}
    vol[k] = toPercent((v.vol || 0) * 100)
    inicio[k] = toPercent((v.inicio || 0) * 100)
    rend[k] = toMoney(v.rendimento || 0)
  }
  return { vol, inicio, rend }
}

export const buildAssetStatsFmt = (statisticsAssets = {}) => {
  const keys = Object.keys(statisticsAssets)
  const res = {}
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (k === 'Todos') continue
    const v = statisticsAssets[k] || {}
    res[k] = {
      rendFmt: toMoney(v.rendimento || 0),
      inicioFmt: toPercent((v.inicio || 0) * 100),
      volFmt: toPercent((v.vol || 0) * 100),
    }
  }
  return res
}

const findCDIBenchmark = (benchmarks) => {
  const list = benchmarks || []
  for (let i = 0; i < list.length; i++) {
    const b = list[i]
    if (b && b.nome === 'CDI') return b
  }
  return {}
}

const resolveBenchmarkId = (mapped, cdiBenchmark) => {
  if (typeof mapped === 'string') return mapped
  if (mapped && (mapped.id_benchmark || mapped.id)) {
    return mapped.id_benchmark || mapped.id
  }
  return cdiBenchmark && cdiBenchmark.id
}

const extractBenchStats = (classStats, benchmarkId) => {
  const st = classStats || {}
  const bs = (st && st.benchmarks_statistics) || {}
  return bs[benchmarkId] || {}
}

const findBenchmarkObj = (benchmarks, benchmarkId) => {
  const list = benchmarks || []
  for (let i = 0; i < list.length; i++) {
    const b = list[i]
    if (b && b.id === benchmarkId) return b
  }
  return {}
}

const isCDIName = (benchmark) => (benchmark && benchmark.nome) === 'CDI'
const safeNumber = (v) => (typeof v === 'number' ? v : 0)
const showName = (name) =>
  name.indexOf(' + ') !== -1 ? '(' + name + ')' : name
const ratioCDIText = (inicio, benchInicio) =>
  toPercent((safeNumber(inicio) / (benchInicio || 1)) * 100) + ' CDI'
const diffText = (inicio, benchInicio) =>
  toDecPercent(safeNumber(inicio) - (benchInicio || 0))
const signFor = (inicio, benchInicio) =>
  safeNumber(inicio) - (benchInicio || 0) >= 0 ? ' + ' : ' '

export const formatClassRent = ({
  classStats = {},
  classBenchStats = {},
  benchmark = {},
}) => {
  const benchName = (benchmark && benchmark.nome) || ''
  const classInicio = (classStats && classStats.inicio) || 0
  const benchInicio = (classBenchStats && classBenchStats.rent_inicio) || 0

  if (isCDIName(benchmark)) {
    return ratioCDIText(classInicio, benchInicio)
  }

  if (benchName) {
    return (
      showName(benchName) +
      signFor(classInicio, benchInicio) +
      diffText(classInicio, benchInicio)
    )
  }

  return diffText(classInicio, benchInicio) || '-'
}
